<template>
<v-container fluid>
	<div v-if="independentChains.length">
		<!--segments tab--><!--table head-->			
		<v-row class="mt-2 total" no-gutters>
			<v-col class="tabCell" v-for="item in headers"
				:key="item">{{item}}
			</v-col>
		</v-row>
		<v-row class="ma-4 total">Online channels</v-row>
		<v-row v-for="chan in marketplaces" :key="chan.id" no-gutters>
			<v-col class="tabCell">{{ chan.name }}</v-col>
			<v-col class="tabCell">{{ margin(chan) }}</v-col>
			<v-col class="tabCell">{{ chan.numbers }}</v-col>
			<v-col class="tabCell">{{ flatFee(chan) }}</v-col>
			<v-col class="tabCell">{{ entryFee(chan) }}</v-col>
			<v-col class="tabCell">{{ chan.trademarkNum }}</v-col>
			<v-col class="tabCell">{{ chan.minPrice }}</v-col>
			<v-col class="tabCell">{{ chan.maxPrice }}</v-col>
			<v-col class="tabCell">{{ chan.mainDesign }}</v-col>
			<v-col class="tabCell">{{ chan.secondDesign }}</v-col>
			<v-col class="tabCell">{{ coverage(chan) }}</v-col>
			<v-col class="tabCell">{{ totalCoverage(chan) }}</v-col>
			<v-col class="tabCell">
				<change-chain :chain="chan"
					:gameId="gameId"
					:round="round">
				</change-chain>
				<delete-chain :chain="chan"
					:gameId="gameId"
					:round="round">
				</delete-chain>
			</v-col> 
		</v-row>
		<v-row class="ma-4 total">Brick & mortar channels</v-row>
		<v-row v-for="chan in chains" :key="chan.id" no-gutters>
			<v-col class="tabCell">{{ chan.name }}</v-col>
			<v-col class="tabCell">{{ margin(chan) }}</v-col>
			<v-col class="tabCell">{{ chan.numbers }}</v-col>
			<v-col class="tabCell">{{ flatFee(chan) }}</v-col>
			<v-col class="tabCell">{{ entryFee(chan) }}</v-col>
			<v-col class="tabCell">{{ chan.trademarkNum }}</v-col>
			<v-col class="tabCell">{{ chan.minPrice }}</v-col>
			<v-col class="tabCell">{{ chan.maxPrice }}</v-col>
			<v-col class="tabCell">{{ chan.mainDesign }}</v-col>
			<v-col class="tabCell">{{ chan.secondDesign }}</v-col>
			<v-col class="tabCell">{{ coverage(chan) }}</v-col>
			<v-col class="tabCell">{{ totalCoverage(chan) }}</v-col>
			<v-col class="tabCell">
				<change-chain :chain="chan"
					:gameId="gameId"
					:round="round">
				</change-chain>
				<delete-chain :chain="chan"
					:gameId="gameId"
					:round="round">
				</delete-chain>
			</v-col>
		</v-row>
	</div>		
</v-container>
</template>
<script>
	import changeChain from './modal/changeChain.vue'
	import deleteChain from './modal/deleteChain.vue'
	
	import numeral from 'numeral'

	export default {
		props: ['gameId', 'round'],
		data (){
			return {
				headers: ['Channels (multibrand)', 'Target retail margin (% of sales)', 'Store count', 'Annual flat fee', 'Entry fee','Number of trademarks','Min price', 'Max price', 'Main design type', 'Second design type', 'Peak market coverage (1 store)','Peak market coverage (total)' ,'Action']
			}
		},		
		computed: {
			independentChains () {
				return this.$store.getters.independentChains
			},
			marketplaces () {
				return this.$store.getters.marketplaces
			},
			chains () {
				return this.$store.getters.chains
			}
		},
		methods: {
			margin (chanel) {
				return numeral(chanel.margin).format('0 %')
			},
			flatFee (chanel) {
				const fee = chanel.flatFee
				if (fee > 0) return numeral(fee).format('0,0[.]0')
				else return ' - '
			},
			entryFee (chanel) {
				const fee = chanel.entryFee
				if (fee > 0) return numeral(fee).format('0,0[.]0')
				else return ' - '
			},
			coverage (chanel) {
				return numeral(chanel.coverage).format('0,0[.]0')
			},
			totalCoverage (chain) {
				let stores = chain.numbers
				if (!parseInt(chain.numbers)) stores = 1
				
				const totalCov = stores * chain.coverage
				return numeral(totalCov).format('0,0[.]0')
			}
		},
		components: {
			changeChain,
			deleteChain
		}
	}
</script>